// TODO: Delete remaining wizard constants once home page is migrated to academy-home-ui
export const wizardEnabledLanguages = ['en', 'fr', 'es', 'ja', 'de', 'pt'];